export enum WorkOrderState {
  Pending = 'Pending',
  Approved = 'Approved',
  Available = 'Available',
  Scheduled = 'Scheduled',
  Open = 'Open',
  Closed = 'Closed',
  Suspended = 'Suspended',
  Surrendered = 'Surrendered',
  Rejected = 'Rejected',
  Overdue = "Reschedule Required",
  PendingXfer = "Transfer Requested",
  XferAcknowledged = "Transfer Requested (Acknowledged)",
  PendingReturn = "Return Requested",
  ReturnAcknowledged = "Return Requested (Acknowledged)",
};

// The backend's work order state: the workOrderState field on work order responses,
// and the values the list endpoints' state filter accepts. Matches the backend's WorkOrderState enum.
export enum CanonicalWorkOrderState {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED',
  CLOSED = 'CLOSED',
  PENDING_RELEASE = 'PENDING_RELEASE',
  TRANSFER_REQUESTED = 'TRANSFER_REQUESTED',
  TRANSFER_APPROVED = 'TRANSFER_APPROVED',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  RETURN_APPROVED = 'RETURN_APPROVED',
  SURRENDERED_AWAITING_ACKNOWLEDGEMENT = 'SURRENDERED_AWAITING_ACKNOWLEDGEMENT',
  SURRENDERED = 'SURRENDERED',
  SURRENDER_RESUMED_AWAITING_ACKNOWLEDGEMENT = 'SURRENDER_RESUMED_AWAITING_ACKNOWLEDGEMENT',
  OPEN_UNDER_TRANSFER = 'OPEN_UNDER_TRANSFER',
  OPEN = 'OPEN',
  SUSPENDED = 'SUSPENDED',
  SCHEDULED = 'SCHEDULED',
  SCHEDULED_STARTABLE = 'SCHEDULED_STARTABLE',
  RESCHEDULE_REQUIRED = 'RESCHEDULE_REQUIRED',
  AVAILABLE = 'AVAILABLE',
}

// map of the portal and backend, Several backend states share one portal,
// so the badge labels and the permission checks in WorkOrderStateService keep their existing states.
export const PORTAL_STATE_BY_CANONICAL_STATE: Record<CanonicalWorkOrderState, WorkOrderState> = {
  [CanonicalWorkOrderState.PENDING_APPROVAL]: WorkOrderState.Pending,
  [CanonicalWorkOrderState.REJECTED]: WorkOrderState.Rejected,
  [CanonicalWorkOrderState.CLOSED]: WorkOrderState.Closed,
  [CanonicalWorkOrderState.PENDING_RELEASE]: WorkOrderState.Approved,
  [CanonicalWorkOrderState.TRANSFER_REQUESTED]: WorkOrderState.PendingXfer,
  [CanonicalWorkOrderState.TRANSFER_APPROVED]: WorkOrderState.XferAcknowledged,
  [CanonicalWorkOrderState.RETURN_REQUESTED]: WorkOrderState.PendingReturn,
  [CanonicalWorkOrderState.RETURN_APPROVED]: WorkOrderState.ReturnAcknowledged,
  [CanonicalWorkOrderState.SURRENDERED_AWAITING_ACKNOWLEDGEMENT]: WorkOrderState.Surrendered,
  [CanonicalWorkOrderState.SURRENDERED]: WorkOrderState.Surrendered,
  [CanonicalWorkOrderState.SURRENDER_RESUMED_AWAITING_ACKNOWLEDGEMENT]: WorkOrderState.Open,
  [CanonicalWorkOrderState.OPEN_UNDER_TRANSFER]: WorkOrderState.Open,
  [CanonicalWorkOrderState.OPEN]: WorkOrderState.Open,
  [CanonicalWorkOrderState.SUSPENDED]: WorkOrderState.Suspended,
  [CanonicalWorkOrderState.SCHEDULED]: WorkOrderState.Scheduled,
  [CanonicalWorkOrderState.SCHEDULED_STARTABLE]: WorkOrderState.Scheduled,
  [CanonicalWorkOrderState.RESCHEDULE_REQUIRED]: WorkOrderState.Overdue,
  [CanonicalWorkOrderState.AVAILABLE]: WorkOrderState.Available,
};
